<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${salesDelivery.code}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="salesDelivery" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "sales-delivery-view-logs",

  components: { LogListTable },

  props: ["salesDelivery"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
